function Top() {
  return <div id="wk-top"></div>;
}

export default Top;
